import { useState } from 'react';

import Stack from '@perpay-web/components/design-system/Stack/Stack';
import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './ApplicationValueProp.scss';

const ApplicationValueProp = ({
    imageSrc,
    className = '',
    welcomeOffer,
    benefitTitle = '',
    benefitsListComponent = null,
    onValuePropView = noop,
}) => {
    const [isExpanded, setExpand] = useState(false);

    const handleExpand = () => {
        if (!isExpanded) {
            onValuePropView();
        }

        setExpand(!isExpanded);
    };

    return (
        <div className={getClassName(styles.wrapper, className)}>
            <div className={styles.section__top}>
                {welcomeOffer ? (
                    <div className={styles['welcome-offer']}>
                        ${welcomeOffer} Welcome Bonus
                    </div>
                ) : null}
                <div className={styles.section__top__inner}>
                    <div className={styles.row}>
                        <div className={styles['section__top-content']}>
                            <img
                                className={styles.image}
                                src={imageSrc}
                                alt='Perpay Card'
                            />
                            <Stack className={styles.text}>
                                <p className={styles['text__line-1']}>
                                    {benefitTitle}
                                </p>
                                <p className={styles['text__line-2']}>
                                    View more benefits
                                </p>
                            </Stack>
                        </div>
                        <div
                            className={styles.arrow}
                            onClick={handleExpand}
                            role='button'
                            tabIndex='0'
                            aria-expanded={isExpanded} // Indicates the current state of the toggle
                            aria-label={
                                isExpanded
                                    ? 'Collapse section'
                                    : 'Expand section'
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ')
                                    handleExpand();
                            }}
                        >
                            <div
                                className={getClassName(
                                    styles.icon,
                                    isExpanded ? styles['icon-revert'] : null,
                                )}
                            />
                        </div>
                    </div>

                    {isExpanded ? (
                        <div className={styles.section__bottom}>
                            <div className={styles['section__bottom-content']}>
                                <Stack className={styles.stack}>
                                    {benefitsListComponent}
                                </Stack>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default ApplicationValueProp;
